import history from 'src/history'
import { defineMessages, useIntl } from 'react-intl'
import classNames from 'classnames'

// Assets
import { FullScreenSvg } from 'src/svgs'

// Components
import { Button } from 'src/Components'

// Constants
import { OVERLAY_HELPERS } from 'src/constants/navigation'

// Styles
import styles from './FullScreenButton.module.scss'

interface FullScreenButtonProps {
  className?: string
}

const FullScreenButton = ({ className }: FullScreenButtonProps) => {
  const intl = useIntl()

  const handleOnClick = () => {
    history.push(OVERLAY_HELPERS.listingDetailsMap.buildPath())
  }

  const messages = defineMessages({
    ariaLabel: {
      id: 'FullScreenButton.ariaLabel',
      defaultMessage:
        'Navigates to full screen google map that is not accessible. Feel free to skip!',
    },
  })

  return (
    <Button
      aria-label={intl.formatMessage(messages.ariaLabel)}
      data-qa='fullScreenButton'
      onClick={handleOnClick}
      className={classNames(styles.button, className)}
    >
      <FullScreenSvg />
    </Button>
  )
}

export default FullScreenButton
